import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { KwikUIButtonModule } from "./button/button.module";
import { KwikUICalendarModule } from "./calendars/calendar/calendar.module";
import { KwikUICheckboxModule } from "./checkbox/checkbox.module";
import { KwikUIStarRatingModule } from "./feedback/star-rating/star-rating.module";
import { KwikUIImageModule } from "./image/image.module";
import { KwikUIInputDateRangeModule } from "./inputs/input-date-range/input-date-range.module";
import { KwikUIInputDateModule } from "./inputs/input-date/input-date.module";
import { KwikUIInputFilesModule } from "./inputs/input-files/input-files.module";
import { KwikUIInputNumberModule } from "./inputs/input-number/input-number.module";
import { KwikUIInputPasswordModule } from "./inputs/input-password/input-password.module";
import { KwikUIInputPhoneModule } from "./inputs/input-phone/input-phone.module";
import { KwikUIInputRadioChipModule } from "./inputs/input-radio-chip/input-radio-chip.module";
import { KwikUIInputRadioModule } from "./inputs/input-radio/input-radio.module";
import { KwikUIInputSelectModule } from "./inputs/input-select/input-select.module";
import { KwikUIInputSliderModule } from "./inputs/input-slider/input-slider.module";
import { KwikUIInputTimeModule } from "./inputs/input-time/input-time.module";
import { KwikUIInputModule } from "./inputs/input/input.module";
import { KwikUITextareaModule } from "./inputs/textarea/textarea.module";
import { KwikUILoaderModule } from "./loader/loader.module";
import { KwikUIStepperModule } from "./navigation/stepper/stepper.module";
import { KwikUIProgressBarModule } from "./progress/progress-bar/progress-bar.module";
import { KwikUIProgressCircleModule } from "./progress/progress-circle/progress-circle.module";
import { KwikUIProgressSegmentedModule } from "./progress/progress-segmented/progress-segmented.module";
import { KwikUITablePaginationModule } from "./tables/table-pagination/table-pagination.module";
import { KwikUITableModule } from "./tables/table/table.module";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    KwikUIButtonModule,
    KwikUICalendarModule,
    KwikUICheckboxModule,
    KwikUIImageModule,
    KwikUIInputDateModule,
    KwikUIInputDateRangeModule,
    KwikUIInputFilesModule,
    KwikUIInputModule,
    KwikUIInputNumberModule,
    KwikUIInputPasswordModule,
    KwikUIInputPhoneModule,
    KwikUIInputRadioModule,
    KwikUIInputRadioChipModule,
    KwikUIInputSelectModule,
    KwikUIInputSliderModule,
    KwikUIInputTimeModule,
    KwikUILoaderModule,
    KwikUIProgressBarModule,
    KwikUIProgressCircleModule,
    KwikUIProgressSegmentedModule,
    KwikUIStarRatingModule,
    KwikUIStepperModule,
    KwikUITableModule,
    KwikUITablePaginationModule,
    KwikUITextareaModule
  ],
  exports: [
    KwikUIButtonModule,
    KwikUICalendarModule,
    KwikUICheckboxModule,
    KwikUIImageModule,
    KwikUIInputDateModule,
    KwikUIInputDateRangeModule,
    KwikUIInputFilesModule,
    KwikUIInputModule,
    KwikUIInputNumberModule,
    KwikUIInputPasswordModule,
    KwikUIInputPhoneModule,
    KwikUIInputRadioModule,
    KwikUIInputRadioChipModule,
    KwikUIInputSelectModule,
    KwikUIInputSliderModule,
    KwikUIInputTimeModule,
    KwikUILoaderModule,
    KwikUIProgressBarModule,
    KwikUIProgressCircleModule,
    KwikUIProgressSegmentedModule,
    KwikUIStarRatingModule,
    KwikUIStepperModule,
    KwikUITableModule,
    KwikUITablePaginationModule,
    KwikUITextareaModule
  ]
})
export class KwikUICoreModule {}
